(function (root) {
  "use strict";

  function normalizeFlightNumber(v) {
    return String(v || "").trim().toUpperCase().replace(/\s+/g, "");
  }

  function isValidFlightNumber(v) {
    var s = normalizeFlightNumber(v);
    if (s.length < 3 || s.length > 10) return false;
    if (!/[A-Z]/.test(s)) return false;
    if (!/\d/.test(s)) return false;
    return /^[A-Z0-9]+$/.test(s);
  }

  function toAdvisedPickupTime(scheduleDateYmd, etaHHMM, offsetMinutes) {
    var off = typeof offsetMinutes === "number" && isFinite(offsetMinutes) ? offsetMinutes : 30;
    if (!scheduleDateYmd || !etaHHMM) return null;
    var date = String(scheduleDateYmd).trim();
    var time = String(etaHHMM).trim().slice(0, 5);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
    if (!/^\d{2}:\d{2}$/.test(time)) return null;
    // Interpreted in local timezone (expected Europe/Amsterdam for Urbixx).
    var d = new Date(date + "T" + time + ":00");
    if (!isFinite(d.getTime())) return null;
    d.setMinutes(d.getMinutes() + off);
    var hh = String(d.getHours()).padStart(2, "0");
    var mm = String(d.getMinutes()).padStart(2, "0");
    return hh + ":" + mm;
  }

  function createDebouncer(ms, fn) {
    var t = null;
    return function () {
      var args = arguments;
      if (t) clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  root.URBIXX_FLIGHT_UTILS = {
    normalizeFlightNumber: normalizeFlightNumber,
    isValidFlightNumber: isValidFlightNumber,
    toAdvisedPickupTime: toAdvisedPickupTime,
    createDebouncer: createDebouncer
  };
})(typeof window !== "undefined" ? window : globalThis);


